export default "__VITE_ASSET__BTEzSSge__"